<template>
  <div class="col-12">
    <b-card>
      <b-card-header>
        {{ title }}
      </b-card-header>
      <b-card-body>
        <table class="table table-striped table-borderless table-responsive-md">
          <thead>
            <tr style="background-color:#ddd;">
              <th style="padding:0; width:30px"></th>
              <th style="padding:0;width:50%;">UNIT NAME</th>
              <th style="padding:0;"></th>
            </tr>
          </thead>
          <draggable :list="courses" :element="'tbody'" @change="changeOrder">
            <tr v-for="course in courses" style="height: 200px;" :key="'course-' + course.id">
              <td style="position: relative; height: 100%; text-align: center; padding-top: 12px;" :class="getRibbonColour(course)">
                <span style="cursor: move;">
                  <font-awesome-icon icon="grip-vertical"></font-awesome-icon>
                </span>
              </td>
              <td>
                <h4>
                  {{ course.ordinal }} - {{ course.name }}

                  <span class="badge badge-success" v-if="course.type === 1">CORE</span>
                  <span class="badge badge-success" v-if="course.type === 2">ELEC</span>
                  <span class="badge badge-success" v-if="course.type === 3">SUB</span>
                </h4>

                <!-- Dates -->
                <div class="row mt-3">
                  <div class="col-6">
                    <label>Commencement Date</label>
                    <div class="input-group">
                      <flat-pickr
                              class="form-control"
                              :disabled="!course.is_enrolled"
                              :config="$dateOptions"
                              v-model="course.commenced_at">
                      </flat-pickr>
                      <div class="input-group-append">
                        <b-button size="sm" @click="course.commenced_at = null" class="float-right" v-if="course.commenced_at">Clear</b-button>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <label>Competent Date</label>
                    <div class="input-group">
                      <flat-pickr
                              class="form-control"
                              :config="$dateOptions"
                              :disabled="!course.is_enrolled"
                              v-model="course.competent_at">
                      </flat-pickr>
                      <div class="input-group-append">
                        <b-button size="sm" @click="course.competent_at = null" v-if="course.competent_at">Clear</b-button>
                      </div>
                    </div>
                  </div>
                  <div class="col-6" v-if="course.has_credit_transfer || course.has_rpl">
                    <label>CT/RPL Date</label>
                    <div class="input-group">
                      <flat-pickr
                              class="form-control"
                              :config="$dateOptions"
                              :disabled="!course.is_enrolled"
                              v-model="course.ct_rpl_date">
                      </flat-pickr>
                      <div class="input-group-prepend">
                        <b-button size="sm" @click="course.ct_rpl_date = null" v-if="course.ct_rpl_date">Clear</b-button>
                      </div>
                    </div>
                  </div>
                  <div class="col-6" v-show="course.changed">
                    <b-form-textarea v-model="course.new_notes" placeholder="Please type reason for changes here"></b-form-textarea>
                  </div>
                </div>
              </td>
              <td style="position: relative; height: 100%">
                <!-- RPL & CT -->
                <div>
                  <table class="text-center table">
                    <tr>
                      <td>Enrolled</td>
                      <td>Enabled</td>
                      <td>RPL</td>
                      <td>CT</td>
                      <td>Manual</td>
                    </tr>
                    <tr>
                      <td>
                        <b-form-checkbox v-model="course.is_enrolled" size="xl" name="check-button" @change="toggleCourse(course,'is_enrolled')"></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox color="primary" v-model="course.is_enabled" :disabled="!course.is_enrolled" @change="toggleCourse(course,'is_enabled')"></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox color="gold" v-model="course.has_rpl" :disabled="!course.is_enrolled" @change="toggleCourse(course,'has_rpl')"></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox color="teal" v-model="course.has_credit_transfer" :disabled="!course.is_enrolled" @change="toggleCourse(course,'has_credit_transfer')"></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox color="yellow" v-model="course.is_complete_manual" :disabled="!course.is_enrolled" @change="toggleCourse(course,'is_complete_manual')"></b-form-checkbox>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5">
                        <loading-button :loading="loading" variant="success" block @submit="$emit('submit')">Save</loading-button>
                      </td>
                    </tr>
                  </table>
                </div>
                <!-- /.row -->
              </td>
            </tr>
          </draggable>
        </table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import findIndex from 'lodash-es/findIndex';
import sortBy from 'lodash-es/sortBy';

export default {
  name: 'StreamUnits',
  methods: {
    getRibbonColour (user_course) {
      if (!user_course.is_enrolled) return 'bg-platinum';
      if (user_course.has_rpl) return 'bg-gold';
      if (user_course.has_credit_transfer) return 'bg-teal';
      if (user_course.is_complete_manual) return 'bg-yellow';
      if (user_course.is_completed) return 'bg-lime text-black';
      if (user_course.is_enabled) return 'bg-blue text-white';
      if (user_course.is_enrolled) return 'bg-orange';
      return 'bg-platinum';
    },
    changeOrder: function () {
      this.courses = this.courses.map((course, index) => {
        course.ordinal = index+1;

        return course;
      });

      return true;
    },
    courseChanged (course) {
      let index = findIndex(this.courses, {id: course.id});
      this.courses[index].changed = true;
    },
    toggleCourse (course, status) {
      console.log('toggleCouse', course.id, status)
      let index = findIndex(this.courses, {id: course.id});

      switch (status) {
        case 'is_enabled':
          course.is_completed = false;
          course.has_credit_transfer = false;
          course.has_rpl = false;
          break;
        case 'is_completed':
          if (course.is_completed) {
            course.is_enabled = false;
            course.has_rpl = false;
            course.has_credit_transfer = false;
          }
          break;
        case 'has_credit_transfer':
          if (course.has_credit_transfer) {
            course.is_completed = true;
            course.is_enabled = false;
            course.has_rpl = false;
            course.has_credit_transfer = true;
          }
          break;
        case 'has_rpl':
          if (course.has_rpl) {
            course.is_completed = true;
            course.is_enabled = false;
            course.has_rpl = true;
            course.has_credit_transfer = false;
          }
          break;
        case 'is_complete_manual':
          if (course.is_complete_manual) {
            course.is_completed = true;
            course.is_enabled = false;
            course.has_rpl = false;
            course.has_credit_transfer = false;
            course.is_complete_manual = true;
          }
          break;
        case 'is_enrolled':
          //course.is_enrolled = !course.is_enrolled;
          if (!course.is_enrolled) {
            course.is_completed = false;
          }
          break;
        default:
          break;
      }

      this.courses[index] = course;
    }
  },
  computed: {
    courses: {
      get () {
        return sortBy(this.value, 'ordinal');
      },
      set (val) {
        this.$emit('input', val);
      }
    }
  },
  mounted () {},
  props: ['title', 'value', 'loading']
};
</script>